export default "__VITE_ASSET__9023791a__"